import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc/ui-design-system';

import { State } from '../redux';

export type Props = State['emConfiguration']['externalFulfillment'];
const ExternalFulfillmentConfiguration: React.FC<Props> = () => {
  return (
    <Box>
      <Box my={4}>
        <Typography variant='subtitle1' paragraph>
          External Fulfillment
        </Typography>
        <Typography>
          Selecting this type of earning mechanism means the offer is externally fulfilled by
          passing the appropriate offer id in the <strong>fulfilled_offer_ids</strong> field of a
          transaction.
        </Typography>
      </Box>
    </Box>
  );
};

export { ExternalFulfillmentConfiguration };
